// The AI Log usage table's formatting (src/pages/audit/AiUsageLog.jsx), kept
// out of the component file so fast refresh stays component-only.

/** 850 ms · 12.4 s · 2 min 5 s · — (t = i18next's t; keys under aiUsage.duration_*) */
export function formatDuration(ms, t) {
    if (ms === null || ms === undefined || !Number.isFinite(Number(ms))) return '—';
    const n = Math.max(0, Number(ms));
    if (n < 1000) return t('aiUsage.duration_ms', { ms: Math.round(n) });
    if (n < 60000) return t('aiUsage.duration_s', { s: (n / 1000).toFixed(1) });
    const m = Math.floor(n / 60000);
    return t('aiUsage.duration_min', { m, s: Math.round((n % 60000) / 1000) });
}
